import {
  CreateCoworkingCustomerModel,
  CoworkingCustomerModel,
  CoworkingCustomerListModel,
  IList,
  List,
  IListResult,
  ListResultDto,
  IPagedResult,
  PagedResultDto,
  Dictionary,
  IDictionary,
  IRequestOptions,
  IRequestConfig,
  getConfigs,
  axios,
  basePath
} from './index.defs';

export class CoworkingCustomerService {
  /** Generate by swagger-axios-codegen */
  // @ts-nocheck
  /* eslint-disable */

  /**
   *
   */
  create(
    params: {
      /** requestBody */
      body?: CreateCoworkingCustomerModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CoworkingCustomerModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/CoworkingCustomer/Create';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  update(
    params: {
      /**  */
      id: string;
      /** requestBody */
      body?: CreateCoworkingCustomerModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/CoworkingCustomer/Update';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);
      configs.params = { id: params['id'] };
      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  getCustomerBy(
    params: {
      /**  */
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CoworkingCustomerModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/CoworkingCustomer/GetCustomerBy';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { id: params['id'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  getAllCustomers(options: IRequestOptions = {}): Promise<CoworkingCustomerListModel[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/CoworkingCustomer/GetAllCustomers';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  deleteCustomerBy(
    params: {
      /**  */
      userId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/CoworkingCustomer/DeleteCustomerBy';

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);
      configs.params = { userId: params['userId'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}
